<template>
  <div class="search_box">
    <el-select v-model="value" v-if="selectIsShow" :clearable="true" :placeholder="placeholder1" @change="changeValue"
      :class="{ changeHeight, changeHeight }">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>

    <div class="chooseTime" v-if="showChoose">
      <div class="timeabout" v-if="titleSHow" style="color:rgba(102,102,102,1)">时间范围：</div>
      <el-date-picker @change='changeTime' value-format="timestamp" v-model="value1" type="daterange"
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
    </div>

    <el-input :placeholder="placeholder2" v-if="inputAndSelectShow" v-model="input3" class="input-with-select"
      :class="{ changeHeight, changeHeight }">
      <el-button slot="append" @click="searchBtn">查询</el-button>
    </el-input>

    <el-input :placeholder="placeholder3" v-if="inputAndSelectShow" v-model="input4" class="input-with-select"
      :class="{ changeHeight, changeHeight }">
      <el-button slot="append" @click="searchSell">查询</el-button>
    </el-input>
  </div>
</template>

<script>
export default {
  props: {
    selectIsShow: {
      type: Boolean,
      default: true
    },
    titleSHow: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: function () {
        return [];
      }
    },
    placeholder1: {
      type: String,
      default: "请选择"
    },
    placeholder2: {
      type: String,
      default: "请输入订单编号/商品名称/姓名"
    },
    placeholder3: {
      type: String,
      default: "请输入销售姓名"
    },
    inputAndSelectShow: {
      type: Boolean,
      default: false
    },
    showChoose: {
      type: Boolean,
      default: false
    },
    changeHeight: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: "",
      input3: "",
      value1: '',
      input4: ''
    };
  },
  methods: {
    searchBtn() {
      this.$emit("searchBtn", this.input3);
    },
    changeValue(e) {
      this.$emit("changeValue", e);
    },
    changeTime(e) {
      this.$emit('changeTime', e)
    },
    searchSell(){
      this.$emit("searchSell", this.input4);
    }
  }
};
</script>

<style lang='less' scoped>
.search_box {
  display: flex;
  align-items: center;

  ::v-deep .el-select {
    margin-right: 20px;
    height: 36px !important;

  }

  ::v-deep .el-input__inner {
    width: 200px;
    height: 36px !important;
  }

  .input-with-select {
    width: 260px;
    border: 1px solid rgba(221, 221, 221, 1);
    border-right: 0px;
    border-radius: 3px;
    margin-left: 10px;

    ::v-deep .el-input__inner {
      width: 220px;
    }

    .el-date-editor {
      width: 360px;
    }

    ::v-deep .el-input-group__append {
      background: rgba(89, 204, 225, 1);
      border: 1px solid rgba(89, 204, 225, 1);
      color: white !important;
    }
  }

  .chooseTime {
    display: flex;
    align-items: center;
    margin-right: 20px;

    .el-date-editor {
      border: 1px solid rgba(221, 221, 221, 1);
      height: 29px;
      width: 229px;

      ::v-deep .el-range-separator {
        display: flex;
        align-items: center;
        margin-right: 5px;
      }

      ::v-deep .el-input__icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

  }

  .changeHeight {
    height: 29px !important;
  }
}
</style>
